import React, { useState, Suspense, useEffect } from "react";
import MyContext from "../../../../context/mycontext.component";
import Photocontainer from "./Photocontainer";
//import LoadedPhotocontainer from './onloadImage/LoadedImage2'
//const Photocontainer = React.lazy(() => import('./Photocontainer'));
//const LoadedPhotocontainer = React.lazy(() => import('./onloadImage/LoadedImage'));

export const PremiumPics = () => {
  const { setisTextInputOrAreaFocus } = useContext(MyContext);
  const [LoadPic, LoadPics] = useState([]);
  const [Photo, photos] = useState([]);
  useEffect(() => {
    if (Photo.length === 0) {
      // fetch(`https://pixabay.com/api/?key=4581280-63c91ad658c69ede7692de09e&q= &pretty=true&per_page=200&safesearch=true`)
      // .then(response => {
      //   if (!response.ok) {
      //     throw Error('not working')
      //   }
      //   return response.json()
      //     .then(allData => {
      //       console.log('response', allData);
      //       photos(allData.hits);
      //     })
      //     .catch(err => {
      //       throw Error(err.message);
      //     });
      // });
    }
  }, []);

  const handlechange = (e) => {
    if (e.key === "Enter") {
      //   console.log(e.target.value)
      //   //searchField({ search: e.target.value })
      //   fetch(`https://pixabay.com/api/?key=4581280-63c91ad658c69ede7692de09e&q=${e.target.value}&pretty=true&per_page=200&safesearch=true`)
      //     .then(response => {
      //       if (!response.ok) {
      //         throw Error('not working')
      //       }
      //       return response.json()
      //         .then(allData => {
      //           console.log('response', allData);
      //           photos(allData.hits);
      //         })
      //         .catch(err => {
      //           throw Error(err.message);
      //         });
      //     });
    }
  };
  return (
    <>
      <div className="searchBarParent" style={{ padding: "0px 12px" }}>
        <span className="material-icons SearchIconCustom">search</span>
        <input
          className="search customInput searchpad mb-1"
          type="search"
          placeholder="Search Photos..."
          onKeyDown={handlechange}
          onFocus={() => setisTextInputOrAreaFocus(true)}
          onBlur={() => setisTextInputOrAreaFocus(false)}
        />
      </div>
      <Photocontainer isUserImage={"false"} Pic={Photo} type={"Images"} />
    </>
  );
};
export default PremiumPics;
